module.exports = __webpack_public_path__ + "static/media/booking-business-lounge@2x.67211e46.png";